// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ModelContainer[data-v-38d11e39]{width:170px;height:100px}.ModelDiv[data-v-38d11e39]{background-color:#e1e1e1;color:#000;width:150px;height:100px;border:2px solid #fff;border-radius:15px;text-align:center;cursor:pointer}", ""]);
// Exports
module.exports = exports;
